import camelCase from 'lodash.camelcase';
import { post, get } from './api';

// export function fetchRequests() {
//     return get('request/userRequests');
// }

export function fetchRequestSearch (subjectName, skipCount) {
    return get('request/search', {subjectName, skipCount});
}

export function fetchRequestFields(products) {
    return post('request/requiredFields', products).then((res) => {
        const normalizeFields = res.data.fields.map((field) => ({
            ...field,
            name: camelCase(field.name),
        }));

        return Promise.resolve({
            ...res,
            data: {
                ...res.data,
                fields: normalizeFields,
            },
        });
    });
}

export function fetchProductDescription(productId) {
    return get('request/getProductDescription', { productId })
        .then((res) => {
            return {
                ...res,
                data: {
                    ...res.data,
                    links: res.data.exampleFile
                        ? res.data.exampleFile.split(';')
                        : [],
                }
            }
        })
}

function filterObj(obj, pred) {
    return Object.keys(obj).reduce((a, k) => {
        if (pred(obj[k])) {
                a[k] = obj[k];
            return a;
        }
        return a;
    }, {});
}

export function createRequest(values) {
    values = Object.assign({}, values, {
        fields: filterObj(values.fields, x => x !== '' && x !== null && x !== undefined)
    });
    return post('request/create', values);
}

export function prolongationMonitoring(values) {
    return post('request/monitoring/prolongation', values);
}

export function fetchAvailableProducts() {
    return get('request/availableProducts');
}

export function searchCompaniesByName(name) {
    return get(`request/getguessfirm?name=${name.trim()}`)
        .then((res) => {
            return Promise.resolve({
                ...res,
                data: res.data
                    ? res.data.map((company) => ({
                        region: company.regionName,
                        address: company.address,
                        inn: company.inn,
                        name: company.name,
                        ogrn: 0,
                    }))
                    : [],
            });
        });
}

export function searchIndividualsByName(fio) {
    return get(`request/getguessip`, fio)
        .then((res) => {
            return Promise.resolve({
                ...res,
                data: res.data
                    ? res.data.map((individual) => ({
                        address: individual.region,
                        region: individual.region,
                        ogrn: individual.ogrn,
                        inn: individual.inn,
                        name: [
                            individual.lastName,
                            individual.firstName,
                            individual.middleName,
                        ].join(' '),
                    }))
                    : [],
            });
        });
}

export function fetchCompanyInfo(inn) {
    return get(`request/getshortreportfirm?inn=${inn}`)
        .then((res) => {
            if (!res.data) {
                throw {
                    status: 400,
                    message: 'Компания не найдена'
                }
            }

            return {
                ...res,
                data: res.data !== null
                    ? {
                        name: res.data.name,
                        inn: res.data.inn,
                        kpp: res.data.kpp,
                        ogrn: res.data.ogrn,
                        okpo: res.data.okpo,
                        address: res.data.address,
                        balances: res.data.reports.map(({ year }) => year),
                    }
                    : undefined,
            };
        });
}

export function fetchReport(link) {
    return get(link, {}, {
        prefix: ''
    });
}



// WEBPACK FOOTER //
// ./src/services/api/request.js